import { Box, Container, Link, Typography } from "@mui/material";

const colors = {
    cream: "#fffaf2",
    paper: "rgba(255, 250, 242, 0.9)",
    ink: "#2a2621",
    muted: "rgba(42, 38, 33, 0.68)",
    brown: "#9b7653",
    brownDark: "#6f5136",
};

function SectionTitle({ children }) {
    return (
        <Typography
            component="h2"
            sx={{
                mt: 5,
                mb: 2,
                fontFamily: '"Quicksand", sans-serif',
                fontSize: {
                    xs: "1.7rem",
                    md: "2.1rem",
                },
                lineHeight: 1.15,
                fontWeight: 700,
                letterSpacing: "-0.04em",
                color: colors.ink,
            }}
        >
            {children}
        </Typography>
    );
}

function TextBlock({ children }) {
    return (
        <Typography
            sx={{
                mb: 2,
                fontFamily: '"Nunito Sans", sans-serif',
                fontSize: {
                    xs: 16,
                    md: 17,
                },
                lineHeight: 1.8,
                color: colors.muted,
            }}
        >
            {children}
        </Typography>
    );
}

function ListBlock({ children }) {
    return (
        <Box
            component="ul"
            sx={{
                pl: 2.5,
                mb: 2,
                color: colors.muted,

                "& li": {
                    mb: 1.2,
                    fontFamily: '"Nunito Sans", sans-serif',
                    fontSize: {
                        xs: 16,
                        md: 17,
                    },
                    lineHeight: 1.7,
                },
            }}
        >
            {children}
        </Box>
    );
}

function AGB() {
    return (
        <Box
            component="main"
            sx={{
                minHeight: "100vh",
                py: {
                    xs: 10,
                    md: 14,
                },
                background:
                    "linear-gradient(180deg, #fffaf2 0%, #f7f1e8 55%, #eef7fa 100%)",
            }}
        >
            <Container
                maxWidth={false}
                sx={{
                    width: "100%",
                    maxWidth: 980,
                    mx: "auto",
                    px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                    },
                }}
            >
                <Box
                    sx={{
                        p: {
                            xs: 3,
                            sm: 4,
                            md: 6,
                        },
                        borderRadius: {
                            xs: 5,
                            md: 7,
                        },
                        backgroundColor: colors.paper,
                        border: "1px solid rgba(155,118,83,0.15)",
                        boxShadow: "0 24px 80px rgba(78,54,30,0.09)",
                    }}
                >
                    <Typography
                        component="p"
                        sx={{
                            mb: 1.2,
                            fontFamily: '"Nunito Sans", sans-serif',
                            fontSize: 13,
                            fontWeight: 900,
                            letterSpacing: "0.17em",
                            textTransform: "uppercase",
                            color: colors.brown,
                        }}
                    >
                        Rechtliches
                    </Typography>

                    <Typography
                        component="h1"
                        sx={{
                            mb: 4,
                            fontFamily: '"Quicksand", sans-serif',
                            fontSize: {
                                xs: "2.6rem",
                                sm: "3.4rem",
                                md: "4.4rem",
                            },
                            lineHeight: 0.98,
                            fontWeight: 700,
                            letterSpacing: "-0.06em",
                            color: colors.ink,
                        }}
                    >
                        Allgemeine Geschäftsbedingungen
                    </Typography>

                    <SectionTitle>1. Geltungsbereich</SectionTitle>

                    <TextBlock>
                        Für alle Bestellungen über unsere Webseite gelten die
                        nachfolgenden AGB. Unsere Webseite richtet sich ausschließlich an
                        Verbraucher.
                    </TextBlock>

                    <TextBlock>
                        Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu
                        Zwecken abschließt, die überwiegend weder ihrer gewerblichen noch
                        ihrer selbständigen beruflichen Tätigkeit zugerechnet werden
                        können. Unternehmer ist eine natürliche oder juristische Person
                        oder eine rechtsfähige Personengesellschaft, die bei Abschluss
                        eines Rechtsgeschäfts in Ausübung ihrer gewerblichen oder
                        selbständigen beruflichen Tätigkeit handelt.
                    </TextBlock>

                    <SectionTitle>
                        2. Vertragspartner, Vertragsschluss, Korrekturmöglichkeiten
                    </SectionTitle>

                    <TextBlock>
                        Der Kaufvertrag kommt zustande mit Hooksieler Lädchen - Mode &
                        Mee(h)r.
                    </TextBlock>

                    <TextBlock>
                        Die Darstellung der Produkte auf der Webseite stellt kein
                        rechtlich bindendes Angebot, sondern einen unverbindlichen
                        Online-Katalog dar. Sie können unsere Produkte zunächst
                        unverbindlich bestellen und Ihre Eingaben vor Absenden Ihrer
                        verbindlichen Bestellung jederzeit korrigieren, indem Sie die
                        hierfür im Bestellablauf vorgesehenen und erläuterten
                        Korrekturhilfen nutzen. Durch Anklicken des Senden Buttons geben
                        Sie eine verbindliche Bestellung ab. Die Bestätigung des Zugangs
                        Ihrer Bestellung erfolgt per E-Mail unmittelbar nach dem Absenden
                        der Bestellung.
                    </TextBlock>

                    <TextBlock>
                        Wann der Vertrag mit uns zustande kommt, richtet sich nach der von
                        Ihnen gewählten Zahlungsart:
                    </TextBlock>

                    <TextBlock>
                        <strong>Rechnung</strong>
                        <br />
                        Wir nehmen Ihre Bestellung durch Versand einer Annahmeerklärung in
                        separater E-Mail oder durch Auslieferung der Ware innerhalb von
                        zwei Tagen an.
                    </TextBlock>

                    <TextBlock>
                        <strong>Vorkasse</strong>
                        <br />
                        Wir nehmen Ihre Bestellung durch Versand einer Annahmeerklärung in
                        separater E-Mail innerhalb von zwei Tagen an, in welcher wir Ihnen
                        unsere Bankverbindung nennen.
                    </TextBlock>

                    <TextBlock>
                        <strong>PayPal</strong>
                        <br />
                        Wir nehmen Ihre Bestellung durch Versand einer Annahmeerklärung in
                        separater E-Mail innerhalb von zwei Tagen an, in welcher Sie über
                        einen Link auf die Webseite des Online-Anbieters PayPal
                        weitergeleitet werden. Dort können Sie Ihre Zahlungsdaten angeben
                        und die Zahlungsanweisung an PayPal bestätigen. Nach Abgabe der
                        Bestellung auf der Website fordern wir PayPal zur Einleitung der
                        Zahlungstransaktion auf und nehmen dadurch Ihr Angebot an.
                    </TextBlock>

                    <TextBlock>
                        <strong>Barzahlung bei Abholung</strong>
                        <br />
                        Sie zahlen den Rechnungsbetrag bei der Abholung bar.
                    </TextBlock>

                    <SectionTitle>
                        3. Vertragssprache, Vertragstextspeicherung
                    </SectionTitle>

                    <TextBlock>
                        Die für den Vertragsschluss zur Verfügung stehende Sprache ist
                        Deutsch.
                    </TextBlock>

                    <TextBlock>
                        Wir speichern den Vertragstext und senden Ihnen die Bestelldaten
                        und unsere AGB in Textform zu. Den Vertragstext können Sie in
                        unserem Kunden-Login einsehen.
                    </TextBlock>

                    <SectionTitle>4. Lieferbedingungen</SectionTitle>

                    <TextBlock>
                        Zuzüglich zu den angegebenen Produktpreisen können noch
                        Versandkosten anfallen. Nähere Bestimmungen zu gegebenenfalls
                        anfallenden Versandkosten erfahren Sie bei den Versand- und
                        Zahlungsvereinbarungen.
                    </TextBlock>

                    <TextBlock>
                        Sie haben grundsätzlich die Möglichkeit der Abholung bei
                        Hooksieler Lädchen - Mode & Mee(h)r, Lange Str. 37, 26434
                        Wangerland OT Hooksiel, Deutschland zu den nachfolgend angegebenen
                        Geschäftszeiten: Dienstag bis Sonntag von 11:00 Uhr bis 16:00 Uhr.
                        Bitte informieren Sie uns spätestens zwei Werktage vor Ihrer
                        Abholung, damit wir die Ware bereitstellen können. Sie können hier
                        auch mit EC-Karte und PIN bezahlen.
                    </TextBlock>

                    <TextBlock>Wir liefern nicht an Packstationen.</TextBlock>

                    <SectionTitle>5. Bezahlung</SectionTitle>

                    <TextBlock>
                        Auf unserer Webseite stehen Ihnen grundsätzlich die folgenden
                        Zahlungsarten zur Verfügung:
                    </TextBlock>

                    <TextBlock>
                        <strong>Vorkasse</strong>
                        <br />
                        Bei Auswahl der Zahlungsart Vorkasse nennen wir Ihnen unsere
                        Bankverbindung in separater E-Mail und liefern die Ware nach
                        Zahlungseingang.
                    </TextBlock>

                    <TextBlock>
                        <strong>PayPal</strong>
                        <br />
                        Bei Auswahl der Zahlungsart PayPal schicken wir Ihnen einen Link
                        per E-Mail, der Sie auf die Webseite des Online-Anbieters PayPal
                        weiterleitet. Um den Rechnungsbetrag über PayPal bezahlen zu
                        können, müssen Sie dort registriert sein bzw. sich erst
                        registrieren, mit Ihren Zugangsdaten legitimieren und die
                        Zahlungsanweisung an uns bestätigen. Nach Abgabe der Bestellung auf
                        der Website fordern wir PayPal zur Einleitung der
                        Zahlungstransaktion auf. Die Zahlungstransaktion wird durch PayPal
                        nach Versendung der Ware automatisch durchgeführt. Weitere Hinweise
                        erhalten Sie beim Bestellvorgang.
                    </TextBlock>

                    <TextBlock>
                        <strong>Rechnung</strong>
                        <br />
                        Sie zahlen den Rechnungsbetrag nach Erhalt der Ware und der
                        Rechnung per Überweisung auf unser Bankkonto. Wir behalten uns vor,
                        den Kauf auf Rechnung nur nach einer erfolgreichen Bonitätsprüfung
                        anzubieten.
                    </TextBlock>

                    <TextBlock>
                        <strong>Barzahlung bei Abholung</strong>
                        <br />
                        Sie zahlen den Rechnungsbetrag bei der Abholung bar.
                    </TextBlock>

                    <SectionTitle>6. Eigentumsvorbehalt</SectionTitle>

                    <TextBlock>
                        Die Ware bleibt bis zur vollständigen Bezahlung unser Eigentum.
                    </TextBlock>

                    <SectionTitle>7. Transportschäden</SectionTitle>

                    <TextBlock>
                        Werden Waren mit offensichtlichen Transportschäden angeliefert, so
                        reklamieren Sie solche Fehler bitte möglichst sofort beim Zusteller
                        und nehmen Sie bitte unverzüglich Kontakt zu uns auf. Die
                        Versäumung einer Reklamation oder Kontaktaufnahme hat für Ihre
                        gesetzlichen Ansprüche und deren Durchsetzung, insbesondere Ihre
                        Gewährleistungsrechte, keinerlei Konsequenzen. Sie helfen uns aber,
                        unsere eigenen Ansprüche gegenüber dem Frachtführer bzw. der
                        Transportversicherung geltend machen zu können.
                    </TextBlock>

                    <SectionTitle>8. Gewährleistung und Garantien</SectionTitle>

                    <TextBlock>
                        Soweit nicht nachstehend ausdrücklich anders vereinbart, gilt das
                        gesetzliche Mängelhaftungsrecht.
                    </TextBlock>

                    <TextBlock>
                        Bei gebrauchten Waren gilt: Wenn der Mangel nach Ablauf eines
                        Jahres ab Ablieferung der Ware auftritt, sind die Mängelansprüche
                        ausgeschlossen. Mängel, die innerhalb eines Jahres ab Ablieferung
                        der Ware auftreten, können im Rahmen der gesetzlichen
                        Verjährungsfrist von zwei Jahren ab Ablieferung der Ware geltend
                        gemacht werden.
                    </TextBlock>

                    <TextBlock>
                        Die vorstehenden Einschränkungen und Fristverkürzungen gelten
                        nicht für Ansprüche aufgrund von Schäden, die durch uns, unsere
                        gesetzlichen Vertreter oder Erfüllungsgehilfen verursacht wurden:
                    </TextBlock>

                    <ListBlock>
                        <li>bei Verletzung des Lebens, des Körpers oder der Gesundheit</li>
                        <li>
                            bei vorsätzlicher oder grob fahrlässiger Pflichtverletzung
                            sowie Arglist
                        </li>
                        <li>
                            bei Verletzung wesentlicher Vertragspflichten, deren Erfüllung
                            die ordnungsgemäße Durchführung des Vertrages überhaupt erst
                            ermöglicht und auf deren Einhaltung der Vertragspartner
                            regelmäßig vertrauen darf, sogenannte Kardinalpflichten
                        </li>
                        <li>im Rahmen eines Garantieversprechens, soweit vereinbart</li>
                        <li>
                            soweit der Anwendungsbereich des Produkthaftungsgesetzes
                            eröffnet ist
                        </li>
                    </ListBlock>

                    <TextBlock>
                        Informationen zu gegebenenfalls geltenden zusätzlichen Garantien
                        und deren genaue Bedingungen finden Sie jeweils beim Produkt und auf
                        besonderen Informationsseiten im Online-Shop.
                    </TextBlock>

                    <SectionTitle>9. Haftung</SectionTitle>

                    <TextBlock>
                        Für Ansprüche aufgrund von Schäden, die durch uns, unsere
                        gesetzlichen Vertreter oder Erfüllungsgehilfen verursacht wurden,
                        haften wir stets unbeschränkt:
                    </TextBlock>

                    <ListBlock>
                        <li>bei Verletzung des Lebens, des Körpers oder der Gesundheit</li>
                        <li>bei vorsätzlicher oder grob fahrlässiger Pflichtverletzung</li>
                        <li>bei Garantieversprechen, soweit vereinbart</li>
                        <li>
                            soweit der Anwendungsbereich des Produkthaftungsgesetzes
                            eröffnet ist
                        </li>
                    </ListBlock>

                    <TextBlock>
                        Bei Verletzung wesentlicher Vertragspflichten, deren Erfüllung die
                        ordnungsgemäße Durchführung des Vertrages überhaupt erst ermöglicht
                        und auf deren Einhaltung der Vertragspartner regelmäßig vertrauen
                        darf, sogenannte Kardinalpflichten, durch leichte Fahrlässigkeit
                        von uns, unseren gesetzlichen Vertretern oder Erfüllungsgehilfen
                        ist die Haftung der Höhe nach auf den bei Vertragsschluss
                        vorhersehbaren Schaden begrenzt, mit dessen Entstehung
                        typischerweise gerechnet werden muss.
                    </TextBlock>

                    <TextBlock>
                        Im Übrigen sind Ansprüche auf Schadensersatz ausgeschlossen.
                    </TextBlock>

                    <SectionTitle>10. Streitbeilegung</SectionTitle>

                    <TextBlock>
                        Die Europäische Kommission stellt eine Plattform zur
                        Online-Streitbeilegung, OS, bereit, die Sie hier finden:{" "}
                        <Link
                            href="https://ec.europa.eu/consumers/odr/"
                            target="_blank"
                            rel="noopener noreferrer"
                            underline="none"
                            sx={{
                                color: colors.brownDark,
                                fontWeight: 800,
                                wordBreak: "break-word",

                                "&:hover": {
                                    color: colors.brown,
                                },
                            }}
                        >
                            https://ec.europa.eu/consumers/odr/
                        </Link>
                        .
                    </TextBlock>

                    <TextBlock>
                        Zur Teilnahme an einem Streitbeilegungsverfahren vor einer
                        Verbraucherschlichtungsstelle sind wir nicht verpflichtet und nicht
                        bereit.
                    </TextBlock>

                    <TextBlock>
                        AGB erstellt mit dem Trusted Shops Rechtstexter in Kooperation mit
                        Wilde Beuger Solmecke Rechtsanwälte.
                    </TextBlock>
                </Box>
            </Container>
        </Box>
    );
}

export default AGB;